import { IInteractionButtonEventArgs } from '@events/student/eventsCreator/inputArgs';
import { createInteractionButtonEvent } from '@events/student/eventsCreator/interactionButton';
import {
  getLoginEvent,
  getLogoutEvent,
  login,
  logout,
} from '@events/student/eventsCreator/session';
import {
  addEventRequest,
  amplitudeConfig,
  getCommonProperties,
  getLocalStorage,
  getUserProperties,
  isAiDebuggingEnabled,
  sendAmplitudeEvent,
} from '@geneo2-web/shared-ui';
import { Resource_ResourceEnum } from '@protos/content_management/content.db_pb';
import {
  CHANGE_PASSWORD,
  CHOOSE_PROFILE,
  DISCLAIMER,
  DOWNLOAD_SETTINGS,
  ENTER_UID,
  ENTER_UID_VK12,
  FAQ,
  HELP,
  HOME,
  HOMEWORK_ACTIVE,
  HOMEWORK_COMPLETED,
  HOMEWORK_START_COVER,
  HOMEWORK_STUDENT_DASHBOARD,
  HOMEWORK_SUBMITTED,
  HOMEWORK_VIEW_RECOMMENDATION,
  LEARN_DASHBOARD,
  LEARN_TOPIC_SELECTION,
  LESSON_VIEW,
  LOGIN,
  LOGIN_PASSWORD,
  LOGIN_UID_PASSWORD,
  MCB_APP_LOGIN,
  MCB_LOGIN,
  NOTIFICATION,
  OFFLINE_LEARN_DASHBOARD,
  OFFLINE_LEARN_TOPIC_SELECTION,
  OFFLINE_LESSON_VIEW,
  OFFLINE_RESOURCE_VIEW,
  OFFLINE_TOPIC_LESSON,
  OTP_SCREEN,
  PERFORMANCE_STUDENT_CHAPTERWISE,
  PERFORMANCE_STUDENT_DASHBOARD,
  PROFILE,
  PROFILE_OTP_SCREEN,
  REGISTRATION,
  RESET_PASSWORD,
  RESET_PASSWORD_OTP,
  RESOURCE_VIEW,
  SEE_ALL_LESSON_PLAN,
  SET_PASSWORD,
  SWITCH_PROFILE,
  TOPIC_LESSON,
  VERIFY_DETAILS,
  VERIFY_EMAIL,
  VERIFY_PHONE,
  VK12_LOGIN_PASSWORD,
} from '../../../routeHandling/RoutesNomenclature';

//* --------------- Login Events ---------------
interface loginProps {
  studentId: number;
  sessionId: string;
  classId?: number | undefined;
  sectionId?: bigint | undefined;
  schoolId?: number | undefined;
  boardId?: number | undefined;
  regionId?: number | undefined;
  mediumId?: number | undefined;
  isOffline: boolean;
}
export const aiLoginEvent = async (props: loginProps) => {
  const {
    studentId,
    sessionId,
    classId,
    sectionId,
    schoolId,
    boardId,
    regionId,
    mediumId,
    isOffline,
  } = props;

  try {
    login({
      studentId: studentId,
      sessionId: sessionId,
      loginTimestamp: new Date(),
    });

    if (classId && sectionId && schoolId && boardId && mediumId) {
      const loginEventData = getLoginEvent({
        classId,
        sectionId,
        schoolId,
        boardId,
        regionId,
        mediumId,
        isOffline,
      });

      if (loginEventData.timestamp) {
        await addEventRequest({
          key: loginEventData.timestamp?.toJsonString(),
          value: loginEventData.toJson(),
        });
      }
      // await StudentEventsAPIServiceV1Client.studentEventProcess(loginEventData);
      //Amplitude
      const eventConfig = amplitudeConfig;
      const commonProperties = getCommonProperties(eventConfig);
      const userProps = {
        userID: studentId ? studentId : getLocalStorage('userId'),
        type: 'student',
        activeSession: getLocalStorage('activeSession'),
        deviceID: getLocalStorage('deviceID'),
        profileLoginDetailsId: getLocalStorage('profileLoginDetailsId'),
      };
      const userProperties = getUserProperties(userProps);
      if (eventConfig && userProps) {
        sendAmplitudeEvent(
          {
            type: 'login_success',
            props: {
              isOffline,
            },
          },
          eventConfig,
          userProps,
          userProperties,
          commonProperties
        );
      }
    }
  } catch (error) {
    if (isAiDebuggingEnabled()) {
      throw error;
    } else {
      console.error(error);
    }
  }
};

//* --------------- Logout Events ---------------

export const aiLogoutEvent = async ({ isOffline }: { isOffline: boolean }) => {
  try {
    logout({ logoutTimestamp: new Date() });

    const logoutEvent = getLogoutEvent({ isOffline: isOffline });

    if (logoutEvent.timestamp) {
      await addEventRequest({
        key: logoutEvent.timestamp?.toJsonString(),
        value: logoutEvent.toJson(),
      });
    }

    // await StudentEventsAPIServiceV1Client.studentEventProcess(logoutEvent);
    //Amplitude
    const eventConfig = amplitudeConfig;
    const commonProperties = getCommonProperties(eventConfig);
    const userProps = {
      userID: getLocalStorage('userId'),
      type: 'student',
      activeSession: getLocalStorage('activeSession'),
      deviceID: getLocalStorage('deviceID'),
      profileLoginDetailsId: getLocalStorage('profileLoginDetailsId'),
    };
    const userProperties = getUserProperties(userProps);
    if (eventConfig && userProps) {
      sendAmplitudeEvent(
        {
          type: 'logout_success',
          props: {
            isOffline,
          },
        },
        eventConfig,
        userProps,
        userProperties,
        commonProperties
      );
    }
  } catch (error) {
    if (isAiDebuggingEnabled()) {
      throw error;
    } else {
      console.error(error);
    }
  }
};

//* --------------- Interaction Events ---------------
interface InteractionArgs extends IInteractionButtonEventArgs {
  pathSegments?: string[];
}

export const interactionEvent = async (props: InteractionArgs) => {
  const { context, name, pathSegments, isOffline } = props;
  let { url } = props;
  if (pathSegments) {
    url = getStudentPathSegmentMapping(pathSegments, isOffline) || '';
  }
  // console.log('interactionEvent:', { url: url, context: context, name: name });
  // else if (!navigator.onLine) {
  else if (isOffline) {
    url = `Offline_${url}`;
  }

  try {
    const interactionEventData = createInteractionButtonEvent({
      url: url,
      context: context,
      name: name,
      // timestamp: new Date(),
      lessonSesssionId: props.lessonSesssionId,
      resourceSesssionId: props.resourceSesssionId,
      homeworkSesssionId: props.homeworkSesssionId,
      isOffline: isOffline,
    });
    // console.log('interactionEventData:', interactionEventData);

    if (interactionEventData.timestamp) {
      await addEventRequest({
        key: interactionEventData.timestamp?.toJsonString(),
        value: interactionEventData.toJson(),
      });
    }

    // const response = await StudentEventsAPIServiceV1Client.studentEventProcess(
    //   interactionEventData
    // );

    //Amplitude
    const eventConfig = amplitudeConfig;
    const commonProperties = getCommonProperties(eventConfig);
    const userProps = {
      userID: getLocalStorage('userId'),
      type: 'student',
      activeSession: getLocalStorage('activeSession'),
      deviceID: getLocalStorage('deviceID'),
      profileLoginDetailsId: getLocalStorage('profileLoginDetailsId'),
    };
    const userProperties = getUserProperties(userProps);
    if (eventConfig && userProps) {
      sendAmplitudeEvent(
        {
          type: name,
          // type: context === 'Login_Navigation_bar' ? 'login_success' : name,
          props: {
            url,
            context,
            name,
            lessonSessionId: props.lessonSesssionId,
            resourceSessionId: props.resourceSesssionId,
            isOffline,
          },
        },
        eventConfig,
        userProps,
        userProperties,
        commonProperties
      );
    }
  } catch (error) {
    if (isAiDebuggingEnabled()) {
      throw error;
    } else {
      console.error(error);
    }
  }
};

// function maps each pathSegment to a corresponding string identifier (key of pathMap)
// returns string depending on isOffline / !navigator.onLine
export function getStudentPathSegmentMapping(
  pathSegments: string[],
  isOffline: boolean
) {
  const removeOfflinePrefix = (path: string) => {
    return path.replace('/offline/', '');
  };

  const pathMap = {
    //& ------------------------- AUTH -------------------------
    [LOGIN.slice(1)]: 'Student_login',
    [ENTER_UID.slice(1)]: 'Student_login',
    [LOGIN_PASSWORD.slice(1)]: 'Student_login_password',
    [RESET_PASSWORD_OTP.slice(1)]: 'Student_reset_password_otp',
    [CHOOSE_PROFILE.slice(1)]: 'Student_choose_profile',
    [SWITCH_PROFILE.slice(1)]: 'Student_switch_profile',
    [RESET_PASSWORD.slice(1)]: 'Student_reset_password',
    [REGISTRATION.slice(1)]: 'Student_registration',
    [VERIFY_DETAILS.slice(1)]: 'Student_verify_details',
    [VERIFY_PHONE.slice(1)]: 'Student_verify_phone',
    [VERIFY_EMAIL.slice(1)]: 'Student_verify_email',
    [SET_PASSWORD.slice(1)]: 'Student_set_password',
    [OTP_SCREEN.slice(1)]: 'Student_otp_screen',
    [PROFILE_OTP_SCREEN.slice(1)]: 'Student_profile_otp_screen',
    [LOGIN_UID_PASSWORD.slice(1)]: 'Student_login_uid_password',
    [ENTER_UID_VK12.slice(1)]: 'Student_login',
    [VK12_LOGIN_PASSWORD.slice(1)]: 'Student_login_password',

    //& ------------------------- HOME -------------------------
    [HOME.slice(1)]: 'Student_Home',

    //& ------------------------- LEARN -------------------------
    [LEARN_DASHBOARD.slice(1)]: 'Student_Learn_dashboard',
    [removeOfflinePrefix(OFFLINE_LEARN_DASHBOARD)]: 'Student_Learn_dashboard',

    [LEARN_TOPIC_SELECTION.slice(1)]: 'Student_Learn_topic',
    [removeOfflinePrefix(OFFLINE_LEARN_TOPIC_SELECTION)]: 'Student_Learn_topic',

    [TOPIC_LESSON.slice(1)]: 'Student_topic_lesson',
    [removeOfflinePrefix(OFFLINE_TOPIC_LESSON)]: 'Student_topic_lesson',

    [LESSON_VIEW.slice(1)]: 'Student_lesson_view',
    [removeOfflinePrefix(OFFLINE_LESSON_VIEW)]: 'Student_lesson_view',

    [RESOURCE_VIEW.slice(1)]: 'Student_resource_view',
    [removeOfflinePrefix(OFFLINE_RESOURCE_VIEW)]: 'Student_resource_view',

    [SEE_ALL_LESSON_PLAN.slice(1)]: 'Student_See_All_Lesson_Plan',

    //& ------------------------- HOMEWORK -------------------------
    [HOMEWORK_STUDENT_DASHBOARD.slice(1)]: 'Student_Homework_dashboard',
    [HOMEWORK_ACTIVE.slice(1)]: 'Student_Homework_active',
    [HOMEWORK_COMPLETED.slice(1)]: 'Student_completed_homework',
    [HOMEWORK_SUBMITTED.slice(1)]: 'Student_homework_submitted',
    [HOMEWORK_START_COVER.slice(1)]: 'Student_homework_start_cover',
    [HOMEWORK_VIEW_RECOMMENDATION.slice(1)]:
      'student_homework_view_recommendation',

    //& ------------------------- PERFORMANCE -------------------------
    [PERFORMANCE_STUDENT_DASHBOARD.slice(1)]: 'Student_performance_dash',
    [PERFORMANCE_STUDENT_CHAPTERWISE.slice(1)]:
      'Student_performance_chapterwise',

    //& ------------------------- SIDEBAR -------------------------
    [PROFILE.slice(1)]: 'Student_profile',
    [NOTIFICATION.slice(1)]: 'Student_notification',
    [HELP.slice(1)]: 'Student_help',
    [FAQ.slice(1)]: 'Student_FAQ',
    [DISCLAIMER.slice(1)]: 'Student_disclaimer',
    [CHANGE_PASSWORD.slice(1)]: 'Student_change_password',
    [DOWNLOAD_SETTINGS.slice(1)]: 'Student_download_settings',

    //& ------------------------- MCB Login -------------------------
    [MCB_LOGIN.slice(1)]: 'Student_login',
    [MCB_APP_LOGIN.slice(1)]: 'Student_login',
  };

  for (const segment of pathSegments) {
    if (pathMap[segment]) {
      // if (!navigator.onLine) return `Offline_${pathMap[segment]}`;
      if (isOffline) return `Offline_${pathMap[segment]}`;
      else return pathMap[segment];
    }
  }
}

export const getResourceType = (number: number): string => {
  // eslint-disable-next-line no-debugger
  return Resource_ResourceEnum[number] || Resource_ResourceEnum[0];
};

/*
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();

  await interactionEvent({
    url: '',
    context: 'context',
    name: 'name',
    pathSegments: pathSegments,
    isOffline: isOffline,
  });

 */
